export default __webpack_public_path__ + "static/property-img-3_768-e1e239e1dc1c874b6cb48318068bc2d1.jpg";